<template>
  <div v-if="opt[0]" >
      <tree-select 
       :options="opt"
  :disable-branch-nodes="true"
  :show-count="true"
  placeholder="请选择基金小镇"
  v-on:select="selectFcode"
      />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import TreeSelect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  // <!-- v-model="opt[0].children[0].id" -->//默认小镇有问题
  export default {
    name: 'CustomTreeSelect',
    components: { TreeSelect },
    ftCode:"",
        props:[
      'opt'    ]   ,
    data() {
      return {
        value: 0,
      }
    },
    methods: {
            selectFcode(val) {
      console.log('selectFcode', val.id)
      this.ftCode = val.id
      this.$emit("getFtcode",this.ftCode)
},
      getTree (tree = []) {
        let arr = [];
        if (tree.length !== 0) {
          tree.forEach(item => {
            let obj = {};
            obj.label = item.categoryName;
            obj.id = item.id;
            if(item.child === 1) {
              obj.children = this.getTree(item.children);
            }
            arr.push(obj);
          });
        }
        return arr
      },
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>